module.exports = __webpack_public_path__ + "assets/icon-nav-leads-upload-component.554feba1.svg";